<template>
  <v-base-toolbar :title="title" @toggle-sidebar="toggleSidebar">
    <v-slide-x-transition>
      <v-breadcrumbs v-if="classification" :items="breadcrumbItems" divider=">" />
    </v-slide-x-transition>
    <v-spacer />
    <!-- Default slot for more content -->
    <slot />
  </v-base-toolbar>
</template>

<script>
import VBaseToolbar from "./BaseToolbar";

const classificationValidator = val => {
  return val === null || (!!val.name && !!val.id && !!val.parentId);
};

/**
 * A toolbar based on the BaseToolbar that add a breadcrumb to show the classification
 * with all its ancestors.
 */
export default {
  components: {
    VBaseToolbar
  },
  props: {
    /* The current active classification that this component will show */
    classification: {
      required: true,
      /* The classification must have 'name', 'id' and 'parentId' to work */
      validator: classificationValidator
    },
    /* All the classifications to generate the breadcrumb */
    classifications: {
      type: Array,
      required: true,
      /* All the classification must pass the validation */
      validator: val => val.every(classificationValidator)
    },
    /* The title of the toolbar */
    title: {
      type: String,
      require: true
    }
  },
  computed: {
    /**
     * Generate the breadcrumb items of the current active classification.
     */
    breadcrumbItems() {
      const classifications = this.classifications;

      function findAncestors(classification) {
        const parent = classifications.find(
          c => c.id === classification.parentId
        );
        if (parent) return [...findAncestors(parent), classification];
        return [classification];
      }

      return findAncestors(this.classification).map(o => ({
        text: o.name,
        disabled: true
      }));
    }
  },
  methods: {
    /* Propagate the event to the parent of this component */
    toggleSidebar() {
      this.$emit("toggle-sidebar");
    }
  }
};
</script>